import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { take } from "rxjs";
import { SessionService } from '../_services/session/session.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {

  const sessionService = inject(SessionService);
  sessionService.sessionData$.pipe(take(1)).subscribe({
    next: user => {
      if (user) {
        const token = (user.token || '').startsWith('Bearer ')
          ? user.token
          : `Bearer ${user.token}`;
           req = req.clone({
          setHeaders: {
            Authorization: token
          }
        })
      }
    },
  })
  return next(req);
};
